import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import GModal from "components/ui/modal/Modal";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemCostAdjustment,
  getCostAdjustmentItems,
  getCostAdjustmentItemsList,
} from "../../services/costAdjustmentItem";

export default function AddItemCostAdjustment({ onClose, id }) {
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();

  const costAdjustMentData = useSelector((state) => state.costAdjustment);

  useEffect(() => {
    dispatch(getCostAdjustmentItems());
  }, [dispatch]);

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.cost_adjustment.add_items")}
        modalContent={
          <Box p={4}>
            <form
              onSubmit={handleSubmit((values) => {
                values.CostAdjustmentItem = values.CostAdjustmentItem?.map(
                  (el) => ({
                    InventoryItemId: el.InventoryItemId,
                    CostAdjustmentId: id,
                  })
                );
                values.UserId = localStorage.getItem("userId");
                if (
                  values.CostAdjustmentItem === undefined ||
                  values.CostAdjustmentItem.length === 0
                ) {
                  toast2({ description: t("validation.choose_first") });
                } else {
                  values.CostAdjustmentItemId = null;
                  dispatch(addItemCostAdjustment(values))
                    .unwrap()
                    .then((_) => {
                      toast({
                        description: t(
                          "pages.cost_adjustment.cost_adjustment_items_add"
                        ),
                      });
                      dispatch(getCostAdjustmentItemsList(id));
                      onClose();
                    });
                }
              })}
            >
              <Stack spacing={6}>
                <MultiSelect
                  title={t("general.items")}
                  data={costAdjustMentData.costAdjustmentItems.map((el) => ({
                    ...el,
                    label: el.InventoryItemNameEng,
                    value: el.InventoryItemId,
                  }))}
                  isMulti={true}
                  isRequired={true}
                  onChange={(e) => setValue("CostAdjustmentItem", e)}
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
}
